import React, { useState } from "react";
import RecentItem from "../recent-summary/parts/RecentItem";
import RecentSummary from "../recent-summary/RecentSummary";
import iconExcel from "../../assets/images/dummy/icon-excel.png";
import { IconCalendar1, IconDownload } from "../../icons/Icon";
import { downloadBinary } from "../../api/promotions";
import { toast } from "../../helpers/smu-alerts/smu-lerts";


const title = "Promociones recientes";
const badgeColor = "#B1E5FC";

const RecentPromotions = ({ promotions, loading }) => {
  const [downloading, setDownloading] = useState(null);

  const download = (promotionCode) => {
    setDownloading(promotionCode);
    downloadBinary([promotionCode])
      .then(({ data, error }) => {
        if (!!error) throw new Error(error?.message);
        const _blob = new Blob([data]);
        const url = window.URL.createObjectURL(_blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Promociones.xlsx");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((err) => {
        console.error(err);//toast({ icon: "error", title: err });
      })
      .finally(() => setDownloading(null));
  };

  return (
    <RecentSummary
      title={title}
      badgeColor={badgeColor}
      noData={!promotions.length}
      loading={loading}
    >
      { promotions.map((p) => (
        <RecentItem
          key={p.ID_PROMO}
          icon={iconExcel}
          primaryInfo={p.DESCRIPCION_PROMO}
          secondaryInfo={
            <>
              Cod: {p.ID_PROMO} | <IconCalendar1 color="#748A9D" />{" "}
              {p.FECHA_INICIO} - {p.FECHA_TERMINO} | {p.ESTATUS}
            </>
          }
          controlIcon={<IconDownload color="#33383F" />}
          control={() => download(p.ID_PROMO)}
          loading={downloading === p.ID_PROMO}
        />
      ))}
    </RecentSummary>
  );
};

export default RecentPromotions;
